import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
export const editProfile = async (data) => {
  const form = new FormData();
  const body = {
    alunoid: _cookies.getItem("auth").user?.alunoid,
    ...data,
  };
  form.append("dados", `[${JSON.stringify(body)}]`);
  const res = await axios.middleware.post("/Social.asmx/AlterarPerfil", form);
  return res[0].data;
};

export const useEditProfile = ({ config } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...config,
    mutationFn: editProfile,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["socialMediaUser"] });
    },
  });
};
